import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getViewedCompanyIDFromPath } from '../api';

export default function useMachineryWebSocket(enabled = true) {
    const [lastMessage, setLastMessage] = useState(null);
    const location = useLocation();

    useEffect(() => {
        if (!enabled) return undefined;

        const token = localStorage.getItem('token');
        const viewedCompanyID = getViewedCompanyIDFromPath(location.pathname);
        const params = new URLSearchParams();
        if (token) params.set('token', token);
        if (viewedCompanyID) params.set('companyID', viewedCompanyID);
        const query = params.toString();
        const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const socket = new WebSocket(`${wsProtocol}//${window.location.host}/ws${query ? `?${query}` : ''}`);

        socket.onopen = () => {
            console.log("WebSocket connection established");
        };

        socket.onmessage = (event) => {
            try {
                const parsed = JSON.parse(event.data);
                // 백엔드 형식이 {type, data}인 경우와 기존 형식이 섞여있을 수 있음 처리
                if (parsed && parsed.type) {
                    setLastMessage(parsed);
                } else {
                    // 예전 방식 호환성 유지용 (데이터만 오는 경우)
                    setLastMessage({ type: 'MACHINERY_STATUS', data: parsed });
                }
            } catch ( err ) {
                console.error("WebSocket JSON parse error:", err);
            }
        };

        socket.onerror = (err) => {
            console.error("Websocket error:", err);  
        };

        return () => {
            socket.close();
        }
    }, [enabled, location.pathname]);
    
    return lastMessage;
}